import React, { Component } from 'react';
import { Form, message, TreeSelect } from 'antd';
import { connect } from 'react-redux';

import { queryOrgList } from '@api/core/org';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeData: [],
      orgUuid: '',
    };
  }

  componentDidMount() {
    this.loadOrg();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.orgUuid !== this.props.orgUuid) {
      this.setState({
        orgUuid: nextProps.orgUuid,
      });
    }
  }

  submit = e => {
    e.preventDefault();
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  onChange = value => {
    this.props.onChange(value);
  };

  /**
   *获取组织列表
   */
  loadOrg = () => {
    const params = {};
    params.uuid = '19F83BB0108B4255AA38D457E3FFF223';
    queryOrgList(params).then(res => {
      if (res.statusCode === 200) {
        const options = [];
        res.data.map(item => {
          const optionItem = {};
          optionItem.label = item.name;
          optionItem.value = item.uuid;
          optionItem.key = item.uuid;
          options.push(optionItem);
          return options;
        });
        this.setState({
          treeData: options,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  onLoadData = treeNode => {
    const arr = [];
    const key = treeNode.props.eventKey;
    const params = {};
    params.uuid = key.split('-')[key.split('-').length - 1];
    return new Promise(resolve => {
      queryOrgList(params).then(res => {
        if (res.statusCode === 200) {
          res.data.map(item => {
            const optionItem = {};
            optionItem.label = item.name;
            optionItem.value = item.uuid;
            optionItem.key = `${key}-${item.uuid}`;
            arr.push(optionItem);
            return arr;
          });
          const treeData = [...this.state.treeData];
          const loop = data => {
            data.forEach(item => {
              if (key.indexOf(item.key) === 0) {
                if (item.children) {
                  resolve();
                  loop(item.children);
                } else if (item.key === key) {
                  if (arr.length > 0) {
                    item.children = arr;
                    this.setState({ treeData }, () => {
                      resolve();
                    });
                  } else if (arr.length === 0) {
                    item.isLeaf = true;
                    this.setState({ treeData }, () => {
                      resolve();
                    });
                  } else {
                    resolve();
                  }
                }
              }
            });
          };
          loop(treeData);
        }
      });
    });
  };

  render() {
    return (
      <TreeSelect
        treeData={this.state.treeData}
        loadData={this.onLoadData}
        dropdownStyle={{
          maxHeight: '500px',
          overflowY: 'scroll',
          width: '200px',
        }}
        onSelect={this.onChange}
        dropdownMatchSelectWidth={false}
        value={this.state.orgUuid}
        placeholder={this.props.placeholder}
      />
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/comm/SelectOrg.js